<template>
  <bootstrap-modal
    class="modal"
    @modal-close="$emit('modal-close')"
  >
    <div
      slot="header"
      class="modal-header"
    >
      <button
        type="button"
        class="close modal__close-button"
        data-dismiss="modal"
        aria-label="Close"
        @click="$emit('modal-close')"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4
        class="modal-title"
      >
        {{ videoTitle }}
      </h4>
    </div>
    <div
      slot="body"
      class="modal-body"
    >
      <vimeo-player
        ref="player"
        :video-url="videoUrl"
        :player-width="videoDimensions.width"
        :player-height="videoDimensions.height"
        :autoplay="true"
      />
    </div>
    <div
      slot="footer"
      class="modal-footer"
    />
  </bootstrap-modal>
</template>

<script>
import BootstrapModal from '@Shared/components/BootstrapModal.vue'
import { vueVimeoPlayer as VimeoPlayer } from 'vue-vimeo-player'

import responsiveBreakpointsMixin from '@Shared/mixins/responsive-breakpoints.js'

export default {
  name: 'JacketSizingVideoModal',
  components: {
    BootstrapModal,
    VimeoPlayer
  },
  mixins: [responsiveBreakpointsMixin],
  props: {
    videoTitle: { type: String, default: null, required: true },
    videoUrl: { type: String, default: null, required: true }
  },
  computed: {
    videoDimensions () {
      const result = { width: 600, height: 300 }

      if (this.isMobile) {
        result.width = 370
        result.height = result.width / 2
      }

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-body {
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/JacketSizing/JacketSizingVideoModal.vue